var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0156 5.01562V3H1.98438V5.01562H18.0156ZM18.0156 15V9H1.98438V15H18.0156ZM18.0156 0.984375C18.5781 0.984375 19.0469 1.1875 19.4219 1.59375C19.7969 1.96875 19.9844 2.4375 19.9844 3V15C19.9844 15.5625 19.7969 16.0469 19.4219 16.4531C19.0469 16.8281 18.5781 17.0156 18.0156 17.0156H1.98438C1.42188 17.0156 0.953125 16.8281 0.578125 16.4531C0.203125 16.0469 0.015625 15.5625 0.015625 15V3C0.015625 2.4375 0.203125 1.96875 0.578125 1.59375C0.953125 1.1875 1.42188 0.984375 1.98438 0.984375H18.0156Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBlue);
export default __webpack_public_path__ + "static/media/card_blue.a0bf136a81204346b077c2bd38af1e8e.svg";
export { ForwardRef as ReactComponent };